import type { CompanySwitchCapabilities, CompanySwitchScope } from './types';

/**
 * Whether the sidebar switch can open at all, and what it offers once open. Company switching is
 * for super admins, staff, and multi-company users; delegation switching is driven solely by the
 * backend-managed DELEGATION_FAKE_ACCESS permission plus the presence of delegations to pick.
 */
export const resolveCompanySwitchCapabilities = ({
	isSuperUser,
	isStaff,
	companyCount,
	delegationCount,
	hasDelegationAccessPermission,
}: CompanySwitchScope): CompanySwitchCapabilities => {
	const canSwitchCompany = isSuperUser || isStaff || companyCount > 1;
	const canSwitchDelegations = hasDelegationAccessPermission && delegationCount > 0;

	return {
		canSwitchCompany,
		canSwitchDelegations,
		canOpenSwitcher: canSwitchCompany || canSwitchDelegations,
	};
};
